import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { StructuredData as StructuredDataType } from './types';

interface StructuredDataProps {
  data: StructuredDataType;
}

export const StructuredData: FC<StructuredDataProps> = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": data.type,
        "name": data.name,
        "description": data.description,
        "url": data.url,
        "image": data.image,
        ...(data.mainEntity && {
          "mainEntity": {
            "@type": data.mainEntity.type,
            "name": data.mainEntity.name,
            "description": data.mainEntity.description
          }
        })
      })}
    </script>
  </Helmet>
);